module.exports = __webpack_public_path__ + "5caf0fa155d2a0bafe0f9e00754b09c5.webp";